exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-new-tag[data-v-c5f403e4]{height:28px;line-height:26px;padding-top:0;padding-bottom:0}.input-new-tag[data-v-c5f403e4]{width:90px;margin-left:10px;vertical-align:bottom}.footer[data-v-c5f403e4]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
